var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import TopPerformingFundsTabs from "@frameworks/shared-library/components/TopPerformingFunds/TopPerformingFundsTabs";
import ComponentWithProvider from "@frameworks/shared-library/components/customHooks/ComponentWithProvider";
import { useParams } from "react-router-dom";
import { integerExp } from "@frameworks/web/utils/regex";
import { useSelector } from "react-redux";
import _ from "underscore";
import di from "@mainDi/features/mutualFund/servicelocator";
import { fundTabs } from "./constants";
var TopPerformingViewAll = function () {
    var device = DeviceContext();
    var directView = ["idea-for-investment", "sector", "index"];
    var _a = useParams(), section = _a.section, subSection = _a.subSection;
    var showTabs = function () {
        integerExp.test(subSection) ? directView.push(section) : null;
        return directView.findIndex(function (x) { return x === section; }) != -1 ? false : true;
    };
    var _b = __read(React.useState(), 2), mutualFundsSchemes = _b[0], setMutualFundsSchems = _b[1];
    var mutualFundsSchemeList = useSelector(function (state) {
        return state.markets.MutualFunds.mutualFundsSchemes.mutualFundsSchemeList;
    }, _.isEqual);
    var searchSortedDataData = useSelector(function (state) {
        return state.markets.MutualFunds.mutualFundsSchemes.updateData;
    }, _.isEqual);
    React.useEffect(function () {
        di.mutualFunds.getMutualFundsHouses();
        di.mutualFunds.exploreFunds();
    }, []);
    React.useEffect(function () {
        if (searchSortedDataData && searchSortedDataData.length > 0) {
            setMutualFundsSchems(searchSortedDataData);
        }
        else {
            setMutualFundsSchems(mutualFundsSchemeList);
        }
    }, [searchSortedDataData]);
    return (React.createElement(GridContainer, { parentClass: device && device.isDesktop ? "my-5 px-md-0" : "p-0 top-fund-mob" },
        React.createElement(ComponentWithProvider, { component: React.createElement(TopPerformingFundsTabs, { viewAll: true, showTabs: showTabs(), mutualFundsSchemeList: mutualFundsSchemes, tabList: fundTabs }) })));
};
export default TopPerformingViewAll;
